import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CotalityStarlings from '../../assets/images/cotality-starlings-bg.png';
import { colors } from '../../theme';

export const GettingStartedHeader = () => (
  <Stack
    minHeight={280}
    bgcolor={colors.black}
    color="white"
    textAlign="center"
    p={8}
    sx={{
      backgroundImage: `url(${CotalityStarlings})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '0% 40%',
    }}
  >
    <Stack>
      <Typography
        variant="h1"
        fontFamily="TWK Everett"
        fontSize={40}
        fontWeight={500}
      >
        Get Started
      </Typography>

      <Typography variant="body1" fontFamily="TWK Everett">
        A snapshot of the journey you take when you start developing with
        Cotality APIs.
      </Typography>
    </Stack>
  </Stack>
);
